import { UPLOAD_FILE_URL } from "../../constants/ApiRoute";
import API from "../comman/API";
import { deCryptFun } from "../comman/CustomFunction";
import { authHeader } from "../comman/MainFunction";

// Uploads the selected files in one request, one "file" form field per file.
// Resolves to the server's [{ fileName, filePath }] list, unchanged, which is
// sent as `files` to attachmentUpsert. Rejects if the upload did not return one
// entry per file, so no selected file is silently dropped.
export const uploadAttachmentFiles = async (files = []) => {
  const formData = new FormData();
  files.forEach((file) => formData.append("file", file));

  const response = await API({
    method: "POST",
    url: UPLOAD_FILE_URL,
    headers: authHeader(),
    data: formData,
  });

  const uploadedFiles = response?.data?.data;
  if (
    response?.data?.status !== "Success" ||
    !Array.isArray(uploadedFiles) ||
    uploadedFiles.length !== files.length
  ) {
    throw new Error(
      response?.data?.message || "Unable to upload the selected files."
    );
  }
  return uploadedFiles;
};

// Message for a failed upload request. Upload errors come back encrypted, like
// other API errors.
export const getUploadErrorMessage = (error) => {
  if (error?.response?.data) {
    try {
      const parsed = JSON.parse(deCryptFun(error.response.data));
      const message = parsed?.message?.message || parsed?.message;
      if (typeof message === "string" && message) return message;
    } catch (parseError) {
      // Not an encrypted API error; fall through to the generic message.
    }
  }
  return error?.message || "Unable to upload the selected files.";
};
